import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../api'
import type { AppConfigDto } from '../dtos'

// Public, unauthenticated app config — fetched once on app mount and read by
// any component that needs to render conditionally on a feature flag.
// Defaults are conservative (everything off) so the UI never accidentally
// exposes a feature the server hasn't opted into.
export const useConfigStore = defineStore('config', () => {
  const chatMediaUploadsEnabled = ref(false)
  const loaded = ref(false)

  async function fetch() {
    try {
      const res = await api.get<AppConfigDto>('/config')
      chatMediaUploadsEnabled.value = res.data.chatMediaUploadsEnabled
    } catch (e) {
      console.error('Failed to fetch app config:', e)
    } finally {
      loaded.value = true
    }
  }

  return { chatMediaUploadsEnabled, loaded, fetch }
})
